import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import images from 'assets/images';

import AppButton from 'components/App/Button';

import { LOCATIONS, ROOM_TYPE } from 'constants/index';

import styles from './RoomCard.module.scss';

function RoomCard(props) {
  const {
    placeId,
    roomData,
    setRoomId,
    onOpenModalDeleteRoom,
  } = props;

  const handleDeleteButtonClick = () => {
    onOpenModalDeleteRoom();
    setRoomId(roomData._id);
  };

  return (
    <div className={styles.Component}>
      <div className="RoomCard__Container">
        <Link to={`${LOCATIONS.LOCATION_DETAIL.EDIT_ROOM}?place=${placeId}&room=${roomData._id}`}>
          <img
            src={roomData.previewImage || images.defaultImageRoom.default}
            className="RoomCard__Image"
            alt="imageRoom"
            loading="lazy"
          />
        </Link>

        <div className="RoomCard__Content">
          <Link
            to={`${LOCATIONS.LOCATION_DETAIL.EDIT_ROOM}?place=${placeId}&room=${roomData._id}`}
            className="RoomCardContent__Body"
          >
            <h5>{roomData.name || ROOM_TYPE[roomData.roomName].label}</h5>

            <p>
              Số khách tiêu chuẩn:
              {' '}
              <strong>{`${roomData.standardGuests ?? roomData.standardCapacity ?? 2} khách`}</strong>
            </p>

            <p>
              Sức chứa tối đa:
              {' '}
              <strong>{`${roomData.maxCapacity ?? roomData.maxGuests ?? (roomData.maxAdults + roomData.maxChildren)} khách`}</strong>
            </p>

            <p>
              Số người lớn tối đa:
              {' '}
              <strong>{`${roomData.maxAdults ?? 0} người lớn`}</strong>
            </p>

            <p>
              Số trẻ em tối đa:
              {' '}
              <strong>{`${roomData.maxChildren ?? 0} trẻ em`}</strong>
            </p>

            <p>
              Số lượng loại này:
              {' '}
              <strong>{roomData.quantity}</strong>
            </p>

            <div className="RoomCardContent__Line" />
          </Link>

          <div className="RoomCardContent__Footer">
            <button className="ButtonDelete" type="button" onClick={handleDeleteButtonClick}>Xoá</button>

            <Link to={`${LOCATIONS.LOCATION_DETAIL.EDIT_ROOM}?place=${placeId}&room=${roomData._id}`}>
              <AppButton>Chỉnh sửa</AppButton>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

RoomCard.propTypes = {
  roomData: PropTypes.instanceOf(Object).isRequired,
  placeId: PropTypes.string.isRequired,
  setRoomId: PropTypes.func.isRequired,
  onOpenModalDeleteRoom: PropTypes.func.isRequired,
};

RoomCard.defaultProps = {

};

export default React.memo(RoomCard);
